<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.6 15">
		<path d="M6.8 8c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-7c-1.6 0-3 1.3-3 3s1.3 3 3 3c1.6 0 3-1.3 3-3s-1.4-3-3-3z"/>
		<path fill="currentColor" d="M13.1 15c-.3 0-.5-.2-.5-.5v-1.4c0-1.6-1.3-3-3-3H4c-1.6 0-3 1.3-3 3v1.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-1.4c0-2.2 1.8-4 4-4h5.6c2.2 0 4 1.8 4 4v1.4c0 .3-.2.5-.5.5z"/>
	</svg>
</template>
